import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "@/locales/en/translation.json";
import translationFR from "@/locales/fr/translation.json";
import translationES from "@/locales/es/translation.json";
import translationDE from "@/locales/de/translation.json";
import translationIT from "@/locales/it/translation.json";
import translationPT from "@/locales/pt/translation.json";
import translationNL from "@/locales/nl/translation.json";
import translationRU from "@/locales/ru/translation.json";
import translationZH from "@/locales/zh/translation.json";
import translationJA from "@/locales/ja/translation.json";
import translationAR from "@/locales/ar/translation.json";
import translationHI from "@/locales/hi/translation.json";

import homeEN from "@/locales/en/home.json";
import homeFR from "@/locales/fr/home.json";
import homeES from "@/locales/es/home.json";
import homeDE from "@/locales/de/home.json";
import homeIT from "@/locales/it/home.json";
import homePT from "@/locales/pt/home.json";
import homeNL from "@/locales/nl/home.json";
import homeRU from "@/locales/ru/home.json";
import homeZH from "@/locales/zh/home.json";
import homeJA from "@/locales/ja/home.json";
import homeAR from "@/locales/ar/home.json";
import homeHI from "@/locales/hi/home.json";

import bassilitradeEN from "@/locales/en/bassilitrade.json";
import bassilitradeFR from "@/locales/fr/bassilitrade.json";
import bassilitradeES from "@/locales/es/bassilitrade.json";
import bassilitradeDE from "@/locales/de/bassilitrade.json";
import bassilitradeIT from "@/locales/it/bassilitrade.json";
import bassilitradePT from "@/locales/pt/bassilitrade.json";
import bassilitradeAR from "@/locales/ar/bassilitrade.json";
import bassilitradeNL from "@/locales/nl/bassilitrade.json";
import bassilitradeRU from "@/locales/ru/bassilitrade.json";
import bassilitradeZH from "@/locales/zh/bassilitrade.json";
import bassilitradeJA from "@/locales/ja/bassilitrade.json";
import bassilitradeHI from "@/locales/hi/bassilitrade.json";

import bassilichataiEN from "@/locales/en/bassilichatai.json";
import bassilichataiFR from "@/locales/fr/bassilichatai.json";
import bassilichataiES from "@/locales/es/bassilichatai.json";
import bassilichataiDE from "@/locales/de/bassilichatai.json";
import bassilichataiIT from "@/locales/it/bassilichatai.json";
import bassilichataiPT from "@/locales/pt/bassilichatai.json";
import bassilichataiAR from "@/locales/ar/bassilichatai.json";
import bassilichataiNL from "@/locales/nl/bassilichatai.json";
import bassilichataiRU from "@/locales/ru/bassilichatai.json";
import bassilichataiZH from "@/locales/zh/bassilichatai.json";
import bassilichataiJA from "@/locales/ja/bassilichatai.json";
import bassilichataiHI from "@/locales/hi/bassilichatai.json";

const resources = {
  en: { translation: translationEN, home: homeEN, bassilitrade: bassilitradeEN, bassilichatai: bassilichataiEN },
  fr: { translation: translationFR, home: homeFR, bassilitrade: bassilitradeFR, bassilichatai: bassilichataiFR },
  es: { translation: translationES, home: homeES, bassilitrade: bassilitradeES, bassilichatai: bassilichataiES },
  de: { translation: translationDE, home: homeDE, bassilitrade: bassilitradeDE, bassilichatai: bassilichataiDE },
  it: { translation: translationIT, home: homeIT, bassilitrade: bassilitradeIT, bassilichatai: bassilichataiIT },
  pt: { translation: translationPT, home: homePT, bassilitrade: bassilitradePT, bassilichatai: bassilichataiPT },
  nl: { translation: translationNL, home: homeNL, bassilitrade: bassilitradeNL, bassilichatai: bassilichataiNL },
  ru: { translation: translationRU, home: homeRU, bassilitrade: bassilitradeRU, bassilichatai: bassilichataiRU },
  zh: { translation: translationZH, home: homeZH, bassilitrade: bassilitradeZH, bassilichatai: bassilichataiZH },
  ja: { translation: translationJA, home: homeJA, bassilitrade: bassilitradeJA, bassilichatai: bassilichataiJA },
  ar: { translation: translationAR, home: homeAR, bassilitrade: bassilitradeAR, bassilichatai: bassilichataiAR },
  hi: { translation: translationHI, home: homeHI, bassilitrade: bassilitradeHI, bassilichatai: bassilichataiHI },
};

// Only initialize i18n on the client side
if (typeof window !== 'undefined' && !i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "en",
      supportedLngs: ["en", "fr", "es", "de", "it", "pt", "nl", "ru", "zh", "ja", "ar", "hi"],
      ns: ["translation", "home", "bassilitrade", "bassilichatai"],
      defaultNS: "translation",
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "querystring", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "i18nextLng",
      },
      // Don't set lng here - let LanguageDetector handle it from localStorage first
      // Only use "en" as fallback if no language is detected
    });
}

export default i18n;
